/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import CashbackRateRepository from '../../repositories/Admin/Stores/CashbackRateRepository';
import { createRestSlice } from '../../utils/RestSlice';

const cashbackRatesRestSlice = createRestSlice({
  resource: 'cashbackRate',
  repository: CashbackRateRepository,
  slices: ['loadCashbackRates', 'updateCashbackRate'],
});

const initialState = {
  ...cashbackRatesRestSlice.initialState,
};

const cashbackRatesSlice = createSlice({
  name: 'cashbackRates',
  initialState,
  reducers: {
    ...cashbackRatesRestSlice.reducers,
  },
});

export default cashbackRatesSlice.reducer;

export const cashbackRatesRestHooks = cashbackRatesRestSlice.hooks(
  cashbackRatesSlice,
  ['admin', 'CashbackRatesSlice']
);
